import { Menu, MenuItem } from '@blueprintjs/core';
import React, { Component } from 'react';


class MenuOpenTrip extends Component {

  render() {

    const activatedOrNoneStatus = 'Activated,None';

    if (this.props.selectedCheckbox === 'isOpenTrip') {
      return (
        <Menu>
          <MenuItem icon="confirm" text="Confirm Provider" id={'isOverlayConfirmProvider'} onClick={this.props.handleConfirmedMenuClick} />
          {/* <MenuItem icon="inheritance" text="Out of Network" id={'isOutOfNetwork'} onClick={this.props.handleConfirmedMenuClick} /> */}
          {this.props.trip !== null && !activatedOrNoneStatus.includes(this.props.trip.willCallStatus) ?
            <MenuItem icon="phone" text="Activate Willcall" id={'isOverlayWillcall'} onClick={this.props.handleConfirmedMenuClick} />
            : null
          }
          <MenuItem icon="undo" text="Cancel Trip" id={'isOverlayConfirmTripCancellation'} onClick={this.props.handleConfirmedMenuClick} />
        </Menu>

      );
    }
    else if (this.props.selectedCheckbox === 'isNonParTrip') {
      return (
        <Menu>
          <MenuItem icon="dollar" text="Complete Non-Par" id={'isDialogNonParComplete'} onClick={this.props.handleConfirmedMenuClick} />
          {this.props.trip !== null && !activatedOrNoneStatus.includes(this.props.trip.willCallStatus) ?
            <MenuItem icon="phone" text="Activate Willcall" id={'isOverlayWillcall'} onClick={this.props.handleConfirmedMenuClick} />
            : null
          }
          <MenuItem icon="undo" text="Cancel trip" id={'isOverlayConfirmTripCancellation'} onClick={this.props.handleConfirmedMenuClick} />
        </Menu>
      );
    }
    return null;
  }
}

export default MenuOpenTrip;
